import { forwardRef } from 'react'

import s from './Textarea.module.scss'

import { ControlsError } from 'components/UI/ControlsError/ControlsError'

export interface TextareaProps
  extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  icon?: React.ReactNode
  error?: string
  height: number | string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function (
  { icon, error, height, ...textareaProps },
  ref
) {
  return (
    <div className={`${s.inCustom}`}>
      <div className={`${s.inWrapper} ${!!error ? s.errorBorder : ''}`}>
        {!!icon && <div className={`${s.iconWrapper}  ${!!error ? s.errorIcon : ''}`}>{icon}</div>}
        <textarea {...textareaProps} style={{ height: height }} ref={ref} />
      </div>
      {error && <ControlsError error={error} />}
    </div>
  )
})
